import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@mui/lab';
import { Box, Typography } from '@mui/material';
import React from 'react';

import { formatDate, formatMoney } from '../../../../functions/utils';
import { TimelineEvent } from './types';

interface RateHistoryTimelineProps {
  timeline: TimelineEvent[];
}

const RateHistoryTimeline: React.FC<RateHistoryTimelineProps> = ({
  timeline,
}) => {
  return (
    <Timeline
      sx={{
        align: 'left',
        paddingLeft: 0,
      }}
    >
      {timeline.map((event, index) => {
        const isPaymentDue = event.event === 'payment_due';
        const icon = isPaymentDue ? (
          <EventAvailableIcon fontSize="small" />
        ) : (
          <AttachMoneyIcon fontSize="small" />
        );

        return (
          <TimelineItem key={index}>
            <TimelineSeparator>
              <TimelineConnector />
              <TimelineDot color="primary" variant="filled">
                {icon}
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <Box sx={{ minWidth: '100px' }}>
                  <Typography variant="body2" color="text.secondary">
                    {formatDate(new Date(event.date), 'dd-mm-yyyy')}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {event.daysSincePayment} días desde venc.
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body2" fontWeight="medium">
                    {event.description}
                  </Typography>
                  {!isPaymentDue &&
                    (event.amount ? (
                      <Box>
                        <Typography variant="body2" color="text.secondary">
                          {formatMoney(event.amount)}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Tasa: {event.applicableRate}%
                        </Typography>
                      </Box>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        Tasa: {event.applicableRate}%
                      </Typography>
                    ))}
                </Box>
              </Box>
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
};

export default RateHistoryTimeline;
